// 这个文件是用来整合组件的
import _Form from './src/form.vue'
import _FormItem from './src/form-item.vue'
import { withInstall } from '@chenms-zj/utils/with-install'

const Form = withInstall(_Form) 
const FormItem = withInstall(_FormItem) 

// 可以通过app.use来使用 也可以通过import的方式单独使用
export { Form, FormItem }

export default {}

export { formItemProps } from './src/form-item'
export { formProps } from './src/form'

export type FormInstance = InstanceType<typeof Form>

// 这里添加的类型，可以在模板中被解析
declare module 'vue' {
  // 我们的接口可以自动合并
  export interface GlobalComponents {
    'cms-form-item': typeof FormItem
    'cms-form': typeof Form
  }
}
